<template>
    <div class="row marketing">
        <div class="col-lg-12">
            <p>Deepen your knowledge by learning from the submissions of your peers.<br> 
                <i style="color:rgba(0,0,0,.2); font-weight:bold;">Submissions ordered by <span style="color:rgba(0,0,0,.4)">Rating</span></i>
            </p>
                
            <div v-for="(item, index) in getSubmissionsAndReviews.slice(0, numDisplayItems)" style="margin-bottom:1em;">
                <div v-if="item.reviewUserId">
                    <!--Toggle OFF-->
                    <div v-if="sNRSelected[index]">
                        <div class="submission">
                            <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">
                                <span class="card-date">{{item.submissionDate}}</span>
                                <div v-if="item.reviewRating">
                                    <span style="font-size: 1em;">Submission</span> by <b>{{ item.submissionUserDisplayName }}</b>:<br>
                                    <span style="color: rgba(0,0,0,.2);">Rating: </span>
                                    <span style="color:#f2c300; font-weight:bold;"> {{item.reviewRating}}<span style="color:rgba(242, 195, 0, .4)">/{{chapterdata.assignmentPoints}}</span> 
                                        <span style="margin-top: -4px; margin-left: -4px;" class="coinicon3"></span>
                                    </span> 
                                </div>
                            </div>
                            <i>{{ item.submissionContentPreview }}..</i>
                            <div style="color: rgba(0,0,0,.2);margin-top:1em;">
                              <span style="font-weight:bold">{{ item.submissionWords }}</span> words
                            </div>
                            <div style="text-align:center; margin-top:1em;">
                              <a href="" @click.prevent="toggleCollapse(index)" class="btn btn-outline-primary">See submission</a>
                            </div>
                        </div>
                    </div>
                    <!--Toggle ON-->
                    <div v-else>
                        <div class="submission">
                            <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">
                                <span class="card-date">{{item.submissionDate}}</span>
                                <div v-if="item.reviewRating">
                                    <span style="font-size: 1em;">Submission</span> by <b>{{ item.submissionUserDisplayName }}</b>:<br>
                                    <span style="color: rgba(0,0,0,.2);">Rating: </span>
                                    <span style="color:#f2c300; font-weight:bold;"> {{item.reviewRating}}<span style="color:rgba(242, 195, 0, .4)">/{{chapterdata.assignmentPoints}}</span> 
                                        <span style="margin-top: -4px; margin-left: -4px;" class="coinicon3"></span>
                                    </span> 
                                </div>
                            </div>
                            <i style="white-space: pre-wrap">{{ item.submissionContent}}</i>
                            <div style="color: rgba(0,0,0,.2);margin-top:1em;">
                              <span style="font-weight:bold">{{ item.submissionWords }}</span> words
                            </div>
                        </div>

                        <div class="review">
                          <div style="padding-bottom: 2em; color: rgba(0,0,0,.54);">
                            <span class="card-date">{{ new Date(item.reviewDate).toDateString() }}</span>
                            <span style="font-size: 1em;">Review</span> by <b>{{ item.reviewUserDisplayName }}</b>:
                          </div>
                          <div style="color:rgba(0,0,0,.80)" v-html="item.reviewContent"></div>
                        </div> 
                        <div style="text-align: center; margin-top:1em;">
                            <a href="" @click.prevent="toggleCollapse(index)" class="btn btn-outline-primary">Hide submission</a>
                        </div>
                        <hr>
                        
                    </div>
                    <!-- dont know why collapse has to be here but doesnt work without it -->
                  <div v-if="!collapse">
                  </div>
                    <!--<transition name="collapse">-->
                    <!--</transition>-->
                    <div v-if="!sNRSelected[index]">
                    </div>
                </div>
            </div>
            
            <div v-if="getSubmissionsAndReviews.length > numDisplayItems">
                <i style="color:rgba(0,0,0,.2);font-weight:bold;">To see more submissions click <a @click.prevent="increaseDisplayItems()" style="color:rgba(0,0,0,.4)">here</a>.</i>
            </div>
            <a class="btn btn-outline-primary btn-lg btn-block" style="margin-top:2em;" @click="NextChapterView(chapterdata)">
              {{getNextchapterName}}
            </a>
            
        </div>
    </div>
</template>

<script>
import { dbReviewsRef } from '../../../firebaseConfig'
import { store } from '../../../store/store.js'

export default {
    props:['chapterdata'],
    data() {
        return{
            currentUser: this.$store.getters.currentUser,
            collapse: true,
            sNRSelected: [],
            numDisplayItems: 10,
            
        }
    },
    computed: {
        getSubmission() {
            var subdata = this.$store.getters.getSubmission2;
            if(subdata){
                var chapterSubmissions = subdata.filter( submission => {
                    return  (submission.chapterId == this.chapterdata.id);
                });
                // console.log(chapterSubmissions)
                return chapterSubmissions;
            }
        },
        getNextchapterName() {
            var chapterId = parseInt(this.$route.params.chapterId);
            //console.log(chapterId)
            //console.log(this.getLCData.chapter.length)
            var name = "Next Chapter"
            if (chapterId+1 === this.getLCData.chapter.length){
                name = "See Certificate"
            }

        return name  
        },
        getNumDisplayItems(){
          return this.numDisplayItems  
        },
        getReview() {
            // var subdata2 = this.$store.getters.getReviews;
            // console.log("test")
            // console.log(subdata2)
            // if(subdata2 && this.currentUser){
            //     var chapterReview = subdata2.filter( review => {
            //         return  (review.chapterId == this.chapterdata.id && review.submissionUserId == this.currentUser.uid );
            //     });
            //     console.log(chapterReview);
            //     return chapterReview[0];
            // }
        },
        getSubmissionsAndReviews() {
            var submissions = this.$store.getters.getSubmission2;
            // console.log("All Submissions")
            // console.log(submissions)
            var chapterSubmissions = submissions.filter( submission => {
                return  (submission.chapterId == this.chapterdata.id);
            });
            // console.log("chapterSubmissions");
            // console.log(chapterSubmissions);
            
            var reviews = this.$store.getters.getReviews;
            // console.log("All reviews")
            // console.log(reviews)
            
            
            var submissionsAndReviews = [];
            for (var i = 0; i < chapterSubmissions.length; i++) {
                    // console.log(chapterSubmissions[i].content);
                    
                    var review = reviews.filter( review => {
                        return  (
                            review.lCId == chapterSubmissions[i].lCId &&
                            review.chapterId == chapterSubmissions[i].chapterId &&
                            review.submissionUserId == chapterSubmissions[i].userId
                        );
                    });
                    // console.log("review")
                    // console.log(review)
                    
                    //var userEmail = chapterSubmissions[i].userEmail;
                    //var userEmailName = userEmail.substring(0, userEmail.lastIndexOf('@') );
                    
                    var maxLength = 160;
                    var trimmedString = chapterSubmissions[i].content.substr(0, maxLength);
                    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
                    //console.log(trimmedString)
                    if (chapterSubmissions[i].content.length>0){
                      var words = chapterSubmissions[i].content.trim().split(/\s+/).length;
                    } else {
                      var words = 0
                    }
                    
                    var submissionDate = new Date(chapterSubmissions[i].date).toDateString()
                    submissionDate = submissionDate.slice(4,-4)
                    //console.log(submissionDate)

                    if (review[0]){
                        submissionsAndReviews.push( { 
                            "lCId":chapterSubmissions[i].lCId,
                            "chapterId":chapterSubmissions[i].chapterId,
                            "submissionUserId":chapterSubmissions[i].userId,
                            "submissionContent":chapterSubmissions[i].content,
                            "submissionContentPreview":trimmedString,
                            "submissionDate":submissionDate,
                            "submissionUserDisplayName":chapterSubmissions[i].displayName,
                            "submissionWords":words,
                            "reviewUserId":review[0].reviewUserId,
                            "reviewUserDisplayName":review[0].reviewDisplayName,
                            "reviewContent":review[0].content,
                            "reviewRating":review[0].rating,
                            "reviewDate":review[0].date
                        } );  
                        this.sNRSelected[i] = true
                    }
            }
            submissionsAndReviews.sort(function(a, b) { 
                return b.reviewRating - a.reviewRating;
            })
        
            return submissionsAndReviews;
        },
        getLCData() {
            var courseId = parseInt(this.$route.params.courseId)
            return this.$store.getters.getCurrentLCData2(courseId)
        },
        
    },
    methods: {
        NextChapterView(chapterdata) {
            var chapterId = parseInt(this.$route.params.chapterId);
            //console.log(chapterId)
            //console.log(this.getLCData.chapter.length)
            if (chapterId+1 === this.getLCData.chapter.length){
                // console.log(chapterdata.id)
                this.$router.push({path: '/course/' + chapterdata.lCId +'/certificate/'});
            } else {
                var nextchapter = chapterId+1
                //console.log(nextchapter)
                // store.dispatch('setChapter', nextchapter);
                this.$router.push({path: '/course/' + chapterdata.lCId + '/chapter/' + nextchapter + '/materials/'});
            }
        },
        toggleCollapse(index){
            //console.log(index)
            this.sNRSelected[index] = !this.sNRSelected[index];
            this.collapse = !this.collapse;
        },
        increaseDisplayItems(){
            this.numDisplayItems = this.numDisplayItems+5
        }
    },
  created() {
    this.$store.dispatch('setReviewsRef', dbReviewsRef)
  }
}
</script>

<style scoped>
.submission {
    border-radius: .3rem;
    background-color: #E1F6F2;
    padding: 1em;
    margin-bottom: 1em;
}

.review {
    border-radius: .3rem;
    background-color: #F2F2f2;
    padding: 1em;
    margin-bottom: 1em;
}

.card-date {
    color: rgba(0,0,0,.2);
    float: right;
}

</style>


// WEBPACK FOOTER //
// src/components/course/chapter/ChapterAllReviews.vue